module.exports = __webpack_public_path__ + "media/src/images/addtoprofilebutton_fr-febf80bf30f076cfaba0870ad7863a78.png";